module.exports = __webpack_public_path__ + "img/st-5.5e5d6426.png";